export default "__VITE_ASSET__CeFJQ4AY__"